import type { NewCustomDimension } from "domains/dimension/dimension.types";
import type { TopicSearchResult } from "domains/search/types";

export enum CustomKeyIssueTypes {
  FETCH_TOPIC_SEARCH = "[Custom Key Issue] - Topic Search",
  FETCH_TOPIC_SEARCH_FULFILLED = "[Custom Key Issue] - Topic Search - Fulfilled",
  FETCH_TOPIC_SEARCH_REJECTED = "[Custom Key Issue] - Topic Search - Rejected",
  CREATE = "[Custom Key Issue] - Create",
  CREATE_FULFILLED = "[Custom Key Issue] - Create - Fulfilled",
  CREATE_REJECTED = "[Custom Key Issue] - Create - Rejected",
  ACTIVATE_FORM = "[Custom Key Issue] - Activate Form",
  RESET_TOPIC_SEARCH_IDS_FOR_QUERY = "Custom Key Issue] - Reset Topic Search Ids For Query",
}

export type CustomKeyIssueTopicSearchDefaultAction = {
  meta: { context?: string; limit?: number; query: string };
  type: CustomKeyIssueTypes.FETCH_TOPIC_SEARCH;
};

export type CustomKeyIssueTopicSearchFulfilledAction = {
  meta: { query: string };
  payload: TopicSearchResult[];
  type: CustomKeyIssueTypes.FETCH_TOPIC_SEARCH_FULFILLED;
};

export type CustomKeyIssueTopicSearchRejectedAction = {
  meta: { query: string };
  type: CustomKeyIssueTypes.FETCH_TOPIC_SEARCH_REJECTED;
};

export type CreateCustomKeyIssueDefaultAction = { meta: NewCustomDimension; type: CustomKeyIssueTypes.CREATE };
export type CreateCustomKeyIssueFulfilledAction = {
  payload: { dimensionId?: string };
  type: CustomKeyIssueTypes.CREATE_FULFILLED;
};
export type CreateCustomKeyIssueRejectedAction = { type: CustomKeyIssueTypes.CREATE_REJECTED };

export type ActivateCreateFormAction = {
  meta?: { id?: string; isActive?: boolean };
  type: CustomKeyIssueTypes.ACTIVATE_FORM;
};

export type CustomKeyIssueResetTopicSearchIdsForQueryAction = {
  type: CustomKeyIssueTypes.RESET_TOPIC_SEARCH_IDS_FOR_QUERY;
};

export type CustomKeyIssueAction =
  | CustomKeyIssueTopicSearchDefaultAction
  | CustomKeyIssueTopicSearchFulfilledAction
  | CustomKeyIssueTopicSearchRejectedAction
  | CreateCustomKeyIssueDefaultAction
  | CreateCustomKeyIssueFulfilledAction
  | CreateCustomKeyIssueRejectedAction
  | ActivateCreateFormAction
  | CustomKeyIssueResetTopicSearchIdsForQueryAction;
